const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/test/ui-meta-field.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { type UiMetaFieldKeyValue, formatStyles } from '@/Components/leva';
import { RelayEnvironment } from '@/graphql/relay-env';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { graphql, loadQuery } from 'react-relay';
import type { Frags_With_UIMetaField_Fragment$data } from '@/graphql/queries/Frags.query';
import type { SiteSettingsUiMetaField } from '@/graphql/types';
import type { uiMetaField_Query } from './__generated__/uiMetaField_Query.graphql';
const fragment = graphql`
  fragment uiMetaField_TestSite on SiteSettings {
    id
    hdLogoText {
      ...Frags_With_UIMetaField_Fragment @relay(mask: false)
    }
    hdLogo {
      ...Frags_With_UIMetaField_Fragment @relay(mask: false)
    }
  }
`;
const query = graphql`
  query uiMetaField_Query {
    siteSettings {
      ...uiMetaField_TestSite @relay(mask: false)
    }
  }
`;
export const Route = createFileRoute('/test/ui-meta-field')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  loader: () => {
    return loadQuery<uiMetaField_Query>(RelayEnvironment, query, {});
  }
});
type UiMetaFieldCondition = {
  type: 'show-on-pages';
  data: string[];
};
type UiMetaFieldConditions = Array<UiMetaFieldCondition>;
const parseConditionsJson = (json: SiteSettingsUiMetaField['conditions']): UiMetaFieldConditions => {
  let conditions: UiMetaFieldConditions = [];
  try {
    conditions = json?.filter(i => !!i)?.map(item => JSON.parse(item ?? '{}')) as UiMetaFieldCondition[];
  } catch (e) {
    console.error('Error parsing conditions JSON:', e);
  }
  return conditions;
};
const conditionsToUiMetaFieldKeyValue = (data: UiMetaFieldConditions) => {
  const conditions: UiMetaFieldKeyValue<'conditions'> = {
    pages: []
  };
  data.forEach(item => {
    if (item.type === 'show-on-pages') {
      conditions.pages = item.data;
    }
  });
  return conditions;
};
type UseUiMetaFieldValuesProps = (Omit<Frags_With_UIMetaField_Fragment$data, ' $fragmentType'> | SiteSettingsUiMetaField) | null | undefined;
export const useUiMetaFieldValues = (props: UseUiMetaFieldValuesProps) => {
  const value = useMemo(() => {
    let uiStyles: React.CSSProperties = {};
    let style = {} as UiMetaFieldKeyValue<'styles'>;
    try {
      style = JSON.parse(props?.style ?? '{}') as UiMetaFieldKeyValue<'styles'>;
      uiStyles = formatStyles(style);
    } catch (e) {
      //
    }
    const conditions = conditionsToUiMetaFieldKeyValue(parseConditionsJson(props?.conditions ?? []));
    return {
      value: props?.value,
      style,
      uiStyles,
      conditions,
      media: {
        file: {
          id: props?.mediaItem?.id ?? null,
          mediaItemUrl: props?.mediaItem?.mediaItemUrl ?? null
        }
      }
    };
  }, [props]);
  return value;
};